import React from 'react';
import { Heading, Text, Button, Cell, Layout } from 'wix-style-react';
import styles from './OrderConfirmationModal.scss';
import { func, string } from 'prop-types';
import ModalLayout from '../ModalLayout';
import classNames from 'classnames';
import { translate } from 'react-i18next';
import Comment from '../Comment';
import { getLatestComment } from '../../utils/OrderUtils';
import { OrderConfirmationSVG } from './OrderConfirmationSVG';

export class OrderConfirmationModalLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animate: false,
      localComment: getLatestComment(props.comments),
    };
  }

  componentDidMount() {
    this.animationFrame = requestAnimationFrame(() => {
      this.setState({
        animate: !this.state.animate,
      });
    });
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationFrame);
  }

  onDoneClick = () => {
    this.props.onDone({ commentStr: this.state.localComment.text });
    this.props.onRequestClose();
  };

  onCommentTextChange = (text) => {
    this.setState({
      localComment: {
        text,
      },
    });
  };

  render() {
    const { deliveryTime, orderNumber, t, locale } = this.props;

    const footer = (
      <div className={styles.footer}>
        <Button onClick={this.onDoneClick} dataHook="order-confirmation-modal-footer-ok-button" size="large">
          {t('phoneordering_checkout_success_cta')}
        </Button>
      </div>
    );

    const { localComment } = this.state;

    return (
      <ModalLayout footer={footer} scrollable={false} size="medium">
        <div
          className={classNames([styles.wrapper, this.state.animate && styles.antimate])}
          data-hook="order-confirmation-modal-wrapper"
        >
          <div className={styles.svgContainer}>
            <OrderConfirmationSVG className={styles.svg} />
          </div>
          <Heading className={styles.title} appearance="H2" data-hook={'order-confirmation-modal-title'}>
            {t('phoneordering_checkout_success_title')}
          </Heading>
          <div className={styles.orderDetails} data-hook={'order-confirmation-modal-delivery-info-wrapper'}>
            <Layout>
              <Cell span={6}>
                <Text
                  size="medium"
                  weight="normal"
                  secondary
                  data-hook={'order-confirmation-modal-delivery-time-title'}
                  tagName="div"
                  className={styles.subtitle}
                >
                  {t('phoneordering_checkout_success_time_label')}
                </Text>
                <Text className={styles.subSubtitle} dataHook="order-confirmation-modal-delivery-time-value">
                  {deliveryTime}
                </Text>
              </Cell>
              <Cell span={6}>
                <Text
                  className={styles.subtitle}
                  size="medium"
                  weight="normal"
                  secondary
                  dataHook="order-confirmation-modal-order-id-title"
                  tagName="div"
                >
                  {t('phoneordering_checkout_success_ordernumber')}
                </Text>
                <Text className={styles.subSubtitle} dataHook="order-confirmation-modal-order-id-value">
                  {`#${orderNumber}`}
                </Text>
              </Cell>
            </Layout>
          </div>
          <div className={styles.comments} data-hook={'order-confirmation-modal-comments-wrapper'}>
            <Comment comment={localComment} onCommentTextChange={this.onCommentTextChange} locale={locale} />
          </div>
        </div>
      </ModalLayout>
    );
  }
}

OrderConfirmationModalLayout.displayName = 'OrderConfirmationModalLayout';
OrderConfirmationModalLayout.propTypes = {
  locale: string,
  deliveryTime: string,
  orderNumber: string,
  onDone: func,
  onRequestClose: func,
  t: func,
};

export default translate()(OrderConfirmationModalLayout);
